/*=========================================================================================
  File Name: starredPages.js
  Description: Vuex Store - starred pages
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    updateStaredPage({commit}, payload) {
        commit('UPDATE_STARED_PAGE', payload);
        axios({url: state.API_URL + '/auth/backend-menus/add-remove-stared', data: payload, method: 'POST'});
    },

    arrangeStaredPagesLimited({commit}, list) {
        commit('ARRANGE_STARED_PAGES_LIMITED', list);
        axios({url: state.API_URL + '/auth/backend-menus/update-order-stared', data: list, method: 'POST'});
    },

    arrangeStaredPagesMore({ commit }, list) {
        commit('ARRANGE_STARED_PAGES_MORE', list);
        axios({url: state.API_URL + '/auth/backend-menus/update-order-stared-more', data: list, method: 'POST'});
    },
};
